import "@/App.css";
import React from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { Toaster } from "@/components/ui/sonner";
import Layout from "@/components/Layout";
import Login from "@/pages/Login";
import CommandCentre from "@/pages/CommandCentre";
import Partners from "@/pages/Partners";
import PartnerDetail from "@/pages/PartnerDetail";
import Projects from "@/pages/Projects";
import ProjectDetail from "@/pages/ProjectDetail";
import Verification from "@/pages/Verification";
import SalesCRM from "@/pages/SalesCRM";
import Tasks from "@/pages/Tasks";
import Distributor from "@/pages/Distributor";
import Loyalty from "@/pages/Loyalty";
import Studio from "@/pages/Studio";
import Audit from "@/pages/Audit";
import Campaigns from "@/pages/Campaigns";
import Reports from "@/pages/Reports";
import Support from "@/pages/Support";
import Comms from "@/pages/Comms";
import Library from "@/pages/Library";
import FuturePage from "@/pages/FuturePage";

function Protected({ children }) {
  const { user } = useAuth();
  if (user === undefined)
    return <div className="min-h-screen grid place-items-center text-slate-400 text-sm">Loading INDIGO…</div>;
  if (!user) return <Navigate to="/login" replace />;
  return <Layout>{children}</Layout>;
}

const P = (el) => <Protected>{el}</Protected>;

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/" element={P(<CommandCentre />)} />
            <Route path="/partners" element={P(<Partners />)} />
            <Route path="/partners/:id" element={P(<PartnerDetail />)} />
            <Route path="/projects" element={P(<Projects />)} />
            <Route path="/projects/:id" element={P(<ProjectDetail />)} />
            <Route path="/verification" element={P(<Verification />)} />
            <Route path="/sales" element={P(<SalesCRM />)} />
            <Route path="/tasks" element={P(<Tasks />)} />
            <Route path="/distributor" element={P(<Distributor />)} />
            <Route path="/loyalty" element={P(<Loyalty />)} />
            <Route path="/studio" element={P(<Studio />)} />
            <Route path="/audit" element={P(<Audit />)} />
            <Route path="/campaigns" element={P(<Campaigns />)} />
            <Route path="/reports" element={P(<Reports />)} />
            <Route path="/support" element={P(<Support />)} />
            <Route path="/comms" element={P(<Comms />)} />
            <Route path="/library" element={P(<Library />)} />
            <Route path="/ai" element={P(<FuturePage title="AI Document Intelligence" desc="Predictive conversion scoring, doc extraction & conversational analytics." p3 />)} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </BrowserRouter>
        <Toaster position="top-right" richColors />
      </AuthProvider>
    </div>
  );
}

export default App;
